<template>
  <RoutesForm :typeEndPoint="'schoolRoutesRoutesShow'" :dataParams="this.$route.params" />
</template>
<script>
import RoutesForm from '@/components/modules/schoolroutes/routes/form'
export default {
  name: 'RoutesFormEdit',
  components: {
    RoutesForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/asignate/edit.vue